<script lang="ts" setup>
	import {getRoundedValue, ignoreKeyPressIfNotInteger, updateOrderLineAmount} from 'dummen-shared';
	import {computed} from 'vue';
	import type {ShoppingCartOrderLine} from 'dummen-shared/src/interfaces/order.line.type.ts';

	const props = defineProps<{
		week: number;
		year: number;
		orderLine: ShoppingCartOrderLine;
		available: number;
		invalid?: boolean;
		tooltip?: string;
	}>();

	const allowOverbooking = computed(() => props.orderLine.allowOverbooking);

	const amountAvailable = computed(() => Math.max(props.available, 0));

	const maxOrderAmount = computed(() => allowOverbooking.value ? undefined : amountAvailable.value);

	const isUnknownVariety = computed(() => props.orderLine?.notExistingVariety);

	const canOrder = computed(() => {
		return !isUnknownVariety.value && (amountAvailable.value > 0 || allowOverbooking.value);
	});

	const amount = computed({
		get() {
			return props.orderLine?.amount ?? 0;
		},

		set(newAmount) {
			if (newAmount === null || newAmount === undefined || !Number.isInteger(newAmount)) {
				return;
			}

			updateOrderLineAmount(props.orderLine, newAmount);
		}
	});

	const setRoundedValue = (event: FocusEvent) => {
		const el = event.target as HTMLInputElement;
		if (!el.value) {
			amount.value = 0;
			return;
		}

		amount.value = getRoundedValue(
			Number.parseInt(el.value),
			amountAvailable.value,
			props.orderLine.packingUnit,
			allowOverbooking.value
		);
	};

</script>

<template>
	<form novalidate onsubmit="return false;">
		<input v-model="amount"
		       :class="{'invalid': invalid}"
		       :disabled="!canOrder"
		       :max="maxOrderAmount"
		       :step="orderLine.packingUnit"
		       :title="tooltip"
		       class="orderinput"
		       min="0"
		       type="number"
		       @blur="setRoundedValue"
		       @keypress="ignoreKeyPressIfNotInteger($event)" />
	</form>
</template>
